import { ToggleSelector } from '@vimily/bonjoro-ui-components-v2/ToggleSelector';
import React from 'react';
import { BillingCycle } from '~/types/models';

export interface BillingCycleTogglerProps {
  billingCycle?: BillingCycle;
  setBillingCycle: (billingCycle: BillingCycle) => void;
}

export function BillingCycleToggler({
  billingCycle,
  setBillingCycle,
}: BillingCycleTogglerProps) {
  return (
    <ToggleSelector
      className='w-full xs:w-[350px]'
      items={{
        [BillingCycle.Yearly]: (
          <div className='flex flex-row flex-wrap gap-x-1.5 justify-center items-center'>
            <span className='text-base font-bold'>Annual</span>
            <span className='text-xs'>Save up to 40%</span>
          </div>
        ),
        [BillingCycle.Monthly]: (
          <span className='text-base font-bold'>Monthly</span>
        ),
      }}
      selected={billingCycle}
      onSelect={(type) => setBillingCycle(type as BillingCycle)}
      textColorClassName='v2-text-neutral-900'
      notSelectedBgColorClassName='v2-bg-white'
      activeButtonClassName='!v2-bg-yellow-100'
      buttonClassName='transition-all !py-0'
      buttonBorderColorClassName='v2-border-transparent'
    />
  );
}
